var Model = require("../../../types/Model.js");

module.exports = new Model({
	name: "deviceForaSPO2",
	listeners: listeners,
	triggers: triggers,
	init: init,
	uninit: uninit,

	handleProgressUpdated: handleProgressUpdated,
	handleFinishReading: handleFinishReading,
	disconnect: disconnect,
	stopMonitor: stopMonitor,
	clean: clean
});

function init() {
	this._isListening = false;
	this._isRead = false;
	this._deviceMac = null;

	this._progress = 0;

	this._batteryReadings = [];
	this._readings = [];
}

function uninit() {
	this._isListening = false;
	this._isRead = false;
	this._deviceMac = null;

	this._progress = 0;

	this._batteryReadings = [];
	this._readings = [];
}

function triggers() {
	return {
		"info": info,
		"ready": ready,
		"clean": clean,
		"disconnect": disconnect,
		"failed": failed
	};
}

function listeners() {
	return {
		"bluetooth:event": handleEvent,
	};
}

function info(){
	var trigger = "deviceoxygen:trigger:begin";
	var message = "myhealthdevice.foraspo2prepmessage";

	this.emit("feedbackmodal:trigger:show", {
		title: "myhealthdevice.prepare_blood_oxygen_reading",
		items: {
			prepare: {
				message: message,
				type: "confirmcancel",
				trigger: trigger,
				cancelTrigger: "myhealthdevice:trigger:clean"
			}
		}
	});

	this.emit("usermetrics:trigger:track", "open read from device modal for blood oxygen", {
		"device type": "ForaSPO2",
	});
}

function ready(data){
	this._deviceMac = data.mac;
	this._isListening = true;

	this.emit("bluetooth:trigger:listen", {
		service: "FORA_TNG_SERVICE",
		characteristic: "FORA_TNG_READWRITE_CHARACTERISTIC",
		device: this._deviceMac
	});

	this.emit("bluetooth:trigger:write", {
		service: "FORA_TNG_SERVICE",
		characteristic: "FORA_TNG_READWRITE_CHARACTERISTIC",
		device: this._deviceMac,
		value: "FORA_TNG_MONITOR_SPO_START"
	});

	// log(this, "OxygenForaReady", this);
}

function handleEvent(event){
	var isListening = this._isListening;
	var readings = this._readings;
	if(!isListening) return;

	var data = event.data;

	var isReading = data.length === 8 && data[1] === 0x61;
	var isReadingDone = data.length === 8 && data[1] === 0x47 && data[2] === 0x00;
	this._isRead = true;

	// log(this, "OxygenForaEvent", this);
	if(isReading){
		this._readings = readings.concat(data);
		this.handleProgressUpdated();
	} else if (isReadingDone){
		this.handleFinishReading();
	}
}

function handleProgressUpdated(){
	var progress = this._progress;

	if(progress < 5) progress++;
	else return this.stopMonitor();

	this.emit("feedbackmodal:trigger:update", {
		reading: {
			type: "progress",
			message: "myhealthdevice.reading",
			progress: progress / 5,
			cancelTrigger: "myhealthdevice:trigger:clean"
		}
	});

	this._progress = progress;
}

function handleFinishReading(){
	var readings = this._readings;
	var isRead = this._isRead;
	if(!isRead) return;

	var reading = formatReading(readings);
	if(!reading) return;

	// log(this, "OxygenForaFinishReading", this);
	this.dispatch("done", reading);
	this.disconnect();
}

function stopMonitor(){
	this.emit("bluetooth:trigger:write", {
		service: "FORA_TNG_SERVICE",
		characteristic: "FORA_TNG_READWRITE_CHARACTERISTIC",
		device: this._deviceMac,
		value: "FORA_TNG_MONITOR_SPO_STOP"
	});
}

function disconnect(){
	var isListening = this._isListening;

	if(isListening){
		this._isListening = false;
		this.emit("bluetooth:trigger:listen:stop", {
			service: "FORA_TNG_SERVICE",
			characteristic: "FORA_TNG_READWRITE_CHARACTERISTIC",
			device: this._deviceMac
		});
	}
	// log(this, "OxygenForaDisconnect", this);
}

function failed(){
	this.emit("feedbackmodal:trigger:show", {
		title: "myhealthdevice.failedtitle",
		items: {
			continue: {
				message: "myhealthdevice.failed",
				type: "confirmcancel",
				trigger: "myhealthdevice:trigger:begin",
				cancelTrigger: "myhealthdevice:trigger:clean"
			}
		}
	});
	// log(this, "OxygenForaFailed", this);
}

function clean(){
	this._isListening = false;
	this._isRead = false;
	this._deviceMac = null;
	this._progress = 0;

	this._readings = [];
	this._batteryReadings = [];
	// log(this, "OxygenForaCleaned", this);
}

function formatReading(readings) {
	var pulseRate = Math.floor((readings.reduce(function (ongoing, next) {
		return ongoing + next[4];
	}, 0)) / readings.length);
	var oxygenSaturation = Math.floor((readings.reduce(function (ongoing, next) {
		return ongoing + next[2];
	}, 0)) / readings.length);

	if (oxygenSaturation > 100 || pulseRate === 255) return false;
	else return {
		pulserate: pulseRate,
		oxygensaturation: oxygenSaturation
	};
}